import { PANEL_MODES } from "../constants/evaluation.constants";
import { PanelMode } from "../types/panel.type";

export const isAiPanelMode = (panelMode: PanelMode) => {
	return (
		panelMode === PANEL_MODES.PANEL_AI || panelMode === PANEL_MODES.SOLO_AI
	);
};

export const isSoloPanelMode = (panelMode: PanelMode) => {
	return (
		panelMode === PANEL_MODES.SOLO_AI || panelMode === PANEL_MODES.SOLO_MANUAL
	);
};
